import { render, staticRenderFns } from "./DirectorQuotaCreate.vue?vue&type=template&id=b4da54be&lang=pug&"
import script from "./DirectorQuotaCreate.vue?vue&type=script&lang=js&"
export * from "./DirectorQuotaCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports